import { useEffect } from "react";
import { MapProtectedRainforestArea } from "types/map";

type Props = {
  areas: Array<MapProtectedRainforestArea>;
  map: google.maps.Map | null; // Map instance passed from MapContainer
  selectedAreaIndex?: number | null;
};

const ZOOM_LEVEL_SINGLE_GEO_FEATURE = 14;

const MapGeoProtectedRegions = ({ map, areas, selectedAreaIndex }: Props) => {
  useEffect(() => {
    if (!map) {
      return;
    }

    // Clear existing data
    map.data.forEach((feature: any) => {
      map.data.remove(feature);
    });

    // Add new GEOJSON data to Map
    areas.forEach((area, index) => {
      try {
        const features = map.data.addGeoJson(area.geoJSON);
        features.forEach((feature) => {
          feature.setProperty("strokeColor", area.areaStrokeColor);
          feature.setProperty("fillColor", area.areaFillColor);
          feature.setProperty("index", index);
        });
      } catch (e) {
        console.error(
          "[Map] MapGeoProtectedRegions Failed to add GeoJSON to map",
          e
        );
      }
    });

    const features: google.maps.Data.Feature[] = [];
    map.data.forEach((feature: google.maps.Data.Feature) => {
      features.push(feature);
    });

    const numFeatures = features.length;

    const bounds = new window.google.maps.LatLngBounds();
    features.forEach((feature) => {
      const geometry = feature.getGeometry();
      if (geometry) {
        geometry.forEachLatLng((latLng: google.maps.LatLng) => {
          bounds.extend(latLng);
        });
      }
    });

    if (numFeatures === 1) {
      const geometry = features[0].getGeometry();
      if (geometry && geometry.getType() === "Point") {
        const point = geometry as google.maps.Data.Point;
        map.setCenter(point.get());
        map.setZoom(ZOOM_LEVEL_SINGLE_GEO_FEATURE);
      } else if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
      }
    } else if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    }

    // Style the features
    map.data.setStyle((feature: any) => {
      const featureIndex = feature.getProperty("index");
      const isSelected = selectedAreaIndex === featureIndex;
      const hasSelection =
        selectedAreaIndex !== null && selectedAreaIndex !== undefined;

      let fillOpacity = 0.3;
      let strokeWeight = 2;

      if (hasSelection && isSelected) {
        fillOpacity = 0.6;
        strokeWeight = 3;
      } else {
        fillOpacity = 0.1;
        strokeWeight = 2;
      }

      return {
        fillColor: feature.getProperty("fillColor"),
        strokeColor: feature.getProperty("strokeColor"),
        strokeWeight,
        fillOpacity,
        zIndex: isSelected ? 1 : 0,
      };
    });
  }, [map, areas, selectedAreaIndex]);

  return <></>;
};

export default MapGeoProtectedRegions;
